module.exports = __webpack_public_path__ + "static/media/campaignData.9055f4f7.png";